<!--<template>
  <div class="tcs-container">
      <div class="container-fluid">
        <div class="grid">
          <div class="tcs-card">
            <img :src="require('../../assets/iahs/training-center.png')" class="img-fluid" alt="" />
            <div class="tcs-widget" :style="{backgroundColor: '#151534'}">
              <div class="sub-title mb-2 white-color" v-html="'Training Center'"></div>
              <div class="title mb-3 white-color" v-html="'Become  An Accredited<br /> Training Center '"></div>
              <div class="tcs-btn">
                <router-link to="/" class="ih-btn">
                  <div class="d-flex align-items-center">
                    <span v-html="'Explore'"></span>
                    <span class="icon-arrow-right ml-2 icon"></span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="cs-card">
            <div class="cs2-card">
              <img :src="require('../../assets/iahs/my-certificate.png')" class="cs2-view img-fluid" alt="" />
              <div class="cs2-details" :style="{borderTop: `5px solid ${'#000000'}`}">
                <div class="bg-title mb-2" :style="{color: '#000000'}" v-html="'My Certificate'"></div>
                <div class="text mb-4" v-html="'You can view and print your certificate'"></div>
                <router-link to="/" class="ih-btn ih-black-btn">
                  <div class="d-flex align-items-center">
                    <span v-html="'Verify Now'"></span>
                    <span class="icon-arrow-right ml-2 icon"></span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="cs2-card">
              <div class="cs2-view" :style="{backgroundColor: `${'#000000'}`}">
                <div class="nw-title white-color">News</div>
              </div>
              <div class="cs2-details" :style="{borderTop: `5px solid ${'#000000'}`}">
                <div class="bg-title mb-2" :style="{color: '#000000'}" v-html="'Subscribe to our<br /> latest insights'"></div>
                <div class="text mb-4" v-html="'Sign-up here to receive our news and briefings'"></div>
                <div class="contact-group">
                  <input type="text" placeholder="Your mail here ">
                  <button class="subscribe-btn"><div class="d-flex align-items-center">Subscribe <span class="icon-back icon"></span></div></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>-->

<template>
  <div class="tcs-container">
      <div class="container-fluid">
        <div class="grid">
          <div class="tcs-card">
            <img :src="row.image7" class="img-fluid" alt="" />
            <div class="tcs-widget" :style="'backgroundColor:'+row.bgColor7">
              <div class="sub-title mb-2 white-color" v-html="row.title7"></div>
              <div class="title mb-3 white-color" v-html="row.body7"></div>
              <div class="tcs-btn">
                <router-link v-if="row.redirect7" :to="row.redirect7" class="ih-btn">
                  <div class="d-flex align-items-center">
                    <span v-html="row.button7"></span>
                    <span class="icon-arrow-right ml-2 icon"></span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="cs-card">
            <div class="cs2-card">
              <img :src="row.image8" class="cs2-view img-fluid" alt="" />
              <div class="cs2-details" :style="'borderTop:'+row.lineColor8">
                <div class="bg-title mb-2" v-html="row.title8"></div>
                <div class="text mb-4" v-html="row.body8"></div>
                <router-link v-if="row.redirect8" :to="row.redirect8" class="ih-btn ih-black-btn">
                  <div class="d-flex align-items-center">
                    <span v-html="row.button8"></span>
                    <span class="icon-arrow-right ml-2 icon"></span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="cs2-card">
              <div class="cs2-view" :style="'backgroundColor:'+row.bgColor9 + ' !important'">
                <div class="nw-title white-color" v-html="row.title9"></div>
              </div>
              <div class="cs2-details" :style="'borderTop:'+row.lineColor9">
                <div class="bg-title mb-2" v-html="row.subTitle9"></div>
                <div class="text mb-4" v-html="row.body9"></div>
                <div class="contact-group">
                  <input v-model="email" type="text" placeholder="Your mail here ">
                  <button @click="newsletter" class="subscribe-btn"><div class="d-flex align-items-center">{{ row.button9 }} <span class="icon-back icon"></span></div></button>
                </div>
                <div v-if="success" style="color: #080" class="alert-msg mt-2">email sent successfully.</div>
                <div v-if="error" style="color: #f00" class="alert-msg mt-2">this email not valid.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<style scoped>
.tcs-container {
  padding-bottom: 70px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 2.2rem;
  width: 100%;
}
.cs-card {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
}
.cs2-card {
  height: calc(50% - 1.1rem);
  width: 100%;
  display: flex;
  /* flex-wrap: wrap; */
}
.cs2-details {
  margin-left: 30px;
  padding-top: 30px;
  line-height: 1;
  width: calc(100% - 300px);
}
.cs2-view {
  height: 100%;
  width: 300px;
  object-fit: cover;
  position: relative;
}
.nw-title {
  position: absolute;
  bottom: 0;
  padding: 18px 25px;
  font-weight: bold;
  font-size: 40px;
}
.tcs-card img {
  height: 350px;
  width: 100%;
  object-fit: cover;
}
.tcs-widget {
  padding: 40px 
}
.title {
  line-height: 1;
  font-size: 39px;
  font-weight: bold;
}
.ih-btn {
  border: 1px solid #fff;
  display: inline-block;
  padding: 5px 18px;
  line-height: 1;
  transition: unset
}
.ih-btn:hover {
  background: #fff;
}
.ih-btn:hover * {
  color: #000;
}
.ih-btn *,
.ih-btn *:before {
  font-size: 18px;
  transition: all 0s ease-in-out !important; 
  -webkit-transition: all 0s ease-in-out !important; 
  -moz-transition: all 0s ease-in-out !important; 
  -o-transition: all 0s ease-in-out !important; 
}
.ih-btn * {
  color: #fff !important;
}
.ih-btn:hover * {
  color: #000 !important;
}
.ih-btn .icon {
  margin-left: 0.5rem !important;
}
.ih-btn:active {
  opacity: 0.6;
}
.ih-btn:active * {
  color: #000 !important;
}
.ih-black-btn {
  border: 1px solid #000;
}
.ih-black-btn * {
  color: #000 !important;
}
.ih-black-btn:hover {
  background: #000;
}
.ih-black-btn:hover * {
  
  color: #fff !important;
}
.text {
  color: #000000;
  font-size: 18px;
}
.contact-group {
  display: flex;
}
.contact-group input {
  background: #fff!important;
  padding: 5px 15px;
  /* min-width: 290px; */
  width: calc(100% - 128px);
  max-width: 100%;
  border: 1px solid #151534;
  border-right: none;
  border-radius: 0 !important;
}
.subscribe-btn {
  background: #B99B47;
  color: #fff;
  padding: 5px 18px;
}
.subscribe-btn:hover {
  background: #a78628;
}
.subscribe-btn:active {
  opacity: 0.6;
}
.subscribe-btn .icon-back:before {
  color: #fff;
  font-weight: 700;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
  .cs2-card {
    display: block;
    height: auto;
    margin-bottom: 40px;
  }
  .cs2-card:last-of-type .cs2-view {
    height: 200px;
  }
  .cs2-view {
    width: 100%;
    height: auto;
  }
  .cs2-details {
    margin-left: 0;
    padding-top: 25px;
    margin-top: 20px;
    width: 100%;
  }
  .tcs-widget {
    padding: 30px;
  }
  .contact-group {
    max-width: 420px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .container-fluid {
    max-width: 720px;
    margin-right: auto;
    margin-left: auto;
  }
  .cs2-details {
    width: calc(100% - 330px);
    padding-top: 19px;
  }
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
  .cs2-details {
    width: auto;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .container-fluid {
    max-width: 1400px;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>

<script>
import axios from 'axios';
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
      email: "",
      error: false,
      success: false
    };
  },
  created() {
      //
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          this.success = false;
        });
    }
  },
};
</script>
